export const nullIfEmpty = string => (string === "" ? null : string);
export const emptyIfNull = value => (value === null ? "" : value);
export const includeIfExist = (field, string) => (string ? `?${field}=${string}` : "");
export const capitalize = string => string.charAt(0).toUpperCase() + string.substr(1);
export const lowerCase = string => string.toLowerCase();
